import "@/App.css";
import "./lib/auth"; // registers axios interceptors
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import DashboardLayout from "@/components/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import TestDashboard from "@/pages/TestDashboard";
import DeepResearch from "@/pages/DeepResearch";
import TradeHistory from "@/pages/TradeHistory";
import Benchmarks from "@/pages/Benchmarks";
import Settings from "@/pages/Settings";
import Optimize from "@/pages/Optimize";
import MyPortfolios from "@/pages/MyPortfolios";
import AutonomousManager from "@/pages/AutonomousManager";
import PortfolioWizard from "@/pages/PortfolioWizard";
import QuickStartPortfolio from "@/pages/QuickStartPortfolio";
import PropTrading from "@/pages/PropTrading";
import UserGuide from "@/pages/UserGuide";
import QuantTools from "@/pages/QuantTools";
import AuraXAUUSD from "@/pages/AuraXAUUSD";
import AuraEURUSD from "@/pages/AuraEURUSD";
import AuraUSDJPY from "@/pages/AuraUSDJPY";
import AuraGBPUSD from "@/pages/AuraGBPUSD";
import AuraGBPJPY from "@/pages/AuraGBPJPY";
import AuraDXY from "@/pages/AuraDXY";
import AuraSP500 from "@/pages/AuraSP500";
import AuraNASDAQ from "@/pages/AuraNASDAQ";
import WealthChallenge from "@/pages/WealthChallenge";
import MorningBriefing from "@/pages/MorningBriefing";
import DailySetups from "./pages/DailySetups";
import WeeklySetups from "./pages/WeeklySetups";
import MyFund from "./pages/MyFund";
import TradeJournal from "./pages/TradeJournal";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="morning-briefing" element={<MorningBriefing />} />
            <Route path="daily-setups" element={<DailySetups />} />
            <Route path="weekly-setups" element={<WeeklySetups />} />
            <Route path="my-fund" element={<MyFund />} />
            <Route path="trade-journal" element={<TradeJournal />} />
            <Route path="challenge" element={<WealthChallenge />} />
            <Route path="my-portfolios" element={<MyPortfolios />} />
            <Route path="wizard" element={<PortfolioWizard />} />
            <Route path="quick-start" element={<QuickStartPortfolio />} />
            <Route path="research" element={<DeepResearch />} />
            <Route path="research/:symbol" element={<DeepResearch />} />
            <Route path="optimize" element={<Optimize />} />
            <Route path="autonomous" element={<AutonomousManager />} />
            <Route path="trades" element={<TradeHistory />} />
            <Route path="benchmarks" element={<Benchmarks />} />
            <Route path="prop-trading" element={<PropTrading />} />
            <Route path="guide" element={<UserGuide />} />
            <Route path="quant-tools" element={<QuantTools />} />
            <Route path="aura-xauusd" element={<AuraXAUUSD />} />
            <Route path="aura-sp500" element={<AuraSP500 />} />
            <Route path="aura-nasdaq" element={<AuraNASDAQ />} />
            <Route path="aura-eurusd" element={<AuraEURUSD />} />
            <Route path="aura-usdjpy" element={<AuraUSDJPY />} />
            <Route path="aura-gbpusd" element={<AuraGBPUSD />} />
            <Route path="aura-gbpjpy" element={<AuraGBPJPY />} />
            <Route path="aura-dxy" element={<AuraDXY />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
      <PWAInstallPrompt />
      </ErrorBoundary>
    </div>
  );
}

export default App;
